import { PageHeader } from '@portals-platform/ui';
import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { CertificateEdit } from '../components/new-certificate/certificate-edit.js';
import { PortalShell } from '../components/portal-shell.js';

const route = getRouteApi('/_authenticated/certificates/$certificateId/edit');

export function EditCertificatePage() {
  const { certificateId } = route.useParams();
  const navigate = useNavigate();

  return (
    <PortalShell activeId="certificates" pageTitle="Edit certificate">
      <div className="mx-auto max-w-[1480px] px-8 pb-12 pt-8">
        <PageHeader
          title="Edit certificate"
          description="Update the draft certificate, then save your changes"
        />
        <CertificateEdit
          certificateId={certificateId}
          onBack={() =>
            void navigate({ to: '/certificates/$certificateId', params: { certificateId } })
          }
        />
      </div>
    </PortalShell>
  );
}
